<template>
   <view class="warp" wx:style="{{warpStyle}}">
    <block wx:if="{{!error}}">
      <text class="rule" wx:style="{{ruleStyle}}" bindtap="gotoLink(pageConfig.rule.link)">规则</text>
      <image class="header-image" webp src="{{pageConfig.header.image2}}" mode="widthFix" />
      <red-packet-open
        wx:if="{{hasGetCoupon && hasCoupon && couponList}}"
        template="{{info.template}}"
        btnText="{{btnText}}"
        couponList="{{couponList}}"
        bind:couponClick="couponToUse"
        bind:click="toUseCoupon"
      />
      <red-packet-close
        wx:elif="{{activityCouponInfo || pageConfig}}"
        config="{{pageConfig.redPacket}}"
        couponInfo="{{activityCouponInfo}}"
        template="{{info.template}}"
        btnText="{{btnText}}"
        bind:click="getCoupon"
      />
      <image-list imageList="{{pageConfig.imageList}}" />
      <res-banner wx:if="{{activityCouponInfo}}" template="{{info.template}}" />
    </block>
    <error-view wx:else message="{{errmsg}}" />
    <popup-result
      wx:if="{{popupResult}}"
      popupData="{{popupResult}}"
      pageConfig="{{pageConfig}}"
      bind:close="popupClose"
      bind:click="popupClick"
    />
  </view> 
</template>

<script>
import { createComponent } from '@mpxjs/core'
import { props as properties } from './model/props'
import { preloadImage } from '../../lib/utils'
import couponMixin from '../../lib/mixin/coupon-v3'

preloadImage([
  'https://ut-static.udache.com/webx/ut/RiBwgvdPYUIea1be1_QlY.png',
  'https://ut-static.udache.com/webx/ut/LBMUijfP-ngrD5uWv2S_9.png',
  'https://ut-static.udache.com/webx/ut/6ZwyueCpT5PX5w9C4ptJZ.png',
], 1000)

createComponent({
  properties,
  mixins: [ couponMixin ],
  data: {
  },
})
</script>

<style lang="stylus" scoped>
  @font-face {
    font-family: DIN-Bold-self;
    src: url(https://dpubstatic.udache.com/static/dpubimg/5e78fa44-928b-4132-aa31-d5bac7b67ece.ttf);
  }
  .warp
    min-height 100vh
    padding-bottom 180rpx
    overflow hidden
    font-size: 0;
    box-sizing: border-box;
    position: relative
    line-height: normal;
    .rule
      position absolute
      right 0
      border-radius: 100rpx 0 0 100rpx;
      font-family: PingFangSC-Semibold;
      font-size: 24rpx;
      letter-spacing: 1rpx;
      font-weight: bold
      padding 4rpx 16rpx 4rpx 25rpx
    .header-image
      width: 750rpx
</style>

<script type="application/json">
{
  "component": true,
  "usingComponents": {
    "red-packet-close": "../../components/common/red-packet-close.mpx",
    "red-packet-open": "../../components/common/red-packet-open.mpx",
    "error-view": "../../components/common/error-view.mpx?async=error-view",
    "popup-result": "../../components/hxz/popup-result.mpx",
    "image-list": "../../components/common/image-list.mpx",
    "res-banner": "../../components/common/res-banner.mpx"
  }
}
</script>